// extracted by mini-css-extract-plugin
module.exports = {"magicTextBoxEditor":"MagicTextBoxEditor_magicTextBoxEditor__ghPnb","editableView":"MagicTextBoxEditor_editableView__uhNIm"};